"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _Text = _interopRequireDefault(require("../Text"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "NavHeader__Container",
  componentId: "j568up-0"
})(["height:4rem;padding:", ";p{transition:", ";", "}"], _units.globalSizes.small, _units.transition.textSlideInOutOpacityIndent, function (props) {
  return props.collapsed ? (0, _styledComponents.css)(["text-indent:-30rem;opacity:0;"]) : (0, _styledComponents.css)(["opacity:1;"]);
});
var AvatarContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "NavHeader__AvatarContainer",
  componentId: "j568up-1"
})(["width:3rem;height:3rem;flex-shrink:0;"]);
var TextContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "NavHeader__TextContainer",
  componentId: "j568up-2"
})(["overflow:hidden;> p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"]);
var HeaderText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "NavHeader__HeaderText",
  componentId: "j568up-3"
})(function (props) {
  return (0, _styledComponents.css)(["font-weight:", ";"], props.theme.font.weight.bold);
});
/**
 *
 * #### Sidebar container component

The **NavHeader** component is intended to be displayed within the **SideBar** component. Its primary purpose is to provide a container to display information related to the current users profile such as their **Avatar**.
 */

var NavHeader = /*#__PURE__*/_react["default"].forwardRef(function NavHeader(_ref, ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      _ref$displayAvatarCog = _ref.displayAvatarCogIcon,
      displayAvatarCogIcon = _ref$displayAvatarCog === void 0 ? false : _ref$displayAvatarCog,
      _ref$avatarImage = _ref.avatarImage,
      avatarImage = _ref$avatarImage === void 0 ? '' : _ref$avatarImage,
      _ref$avatarTitle = _ref.avatarTitle,
      avatarTitle = _ref$avatarTitle === void 0 ? '' : _ref$avatarTitle,
      _ref$onAvatarClick = _ref.onAvatarClick,
      onAvatarClick = _ref$onAvatarClick === void 0 ? null : _ref$onAvatarClick;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    element: "header",
    align: "center",
    gap: "small",
    collapsed: collapsed,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(AvatarContainer, {
    padding: "none"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    onClick: onAvatarClick,
    displayCogIcon: displayAvatarCogIcon,
    image: avatarImage,
    title: avatarTitle
  })), /*#__PURE__*/_react["default"].createElement(TextContainer, null, /*#__PURE__*/_react["default"].createElement(HeaderText, {
    type: "body"
  }, label), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    type: "caption"
  }, message)));
});

var _default = NavHeader;
exports["default"] = _default;